var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ConfirmModal from "./ConfirmModal";

class ConfirmButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.openModal = this.openModal.bind(this);
    this.onAccept = this.onAccept.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  onAccept() {
    this.closeModal();
    this.props.action();
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  render() {
    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("button", { type: "button", className: this.props.className, onClick: this.openModal }, void 0,
      this.props.children
      ),
      this.state.showModal && /*#__PURE__*/
      _jsx(ConfirmModal, {
        message: this.props.message,
        title: this.props.title,
        onAccept: this.onAccept,
        onCancel: this.closeModal }
      )

      ));

  }
}

ConfirmButton.defaultProps = {
  children: '',
  message: 'Are you sure you want to continue?',
  title: 'Confirm action',
  className: '',
  action: () => false
};













export default ConfirmButton;